import { createFileRoute } from "@tanstack/react-router";
import PositionSearch from "@/features/job-offer/PositionSearch";
export const Route = createFileRoute("/_provider/provider/shifts/search/")({
  component: PositionSearch,
});
